import React from 'react';
import MedopsLogo from '@components/system/MyIcons/MedopsLogo';
import {
  Card,
  CardContent,
  createStyles,
  makeStyles,
  Typography
} from '@material-ui/core';
import {ErrorOutlined as LinkDisconnectedIcon} from '@material-ui/icons';
import {useTranslation} from 'react-i18next';
import {DEFAULT_WHITE_COLOR} from '../../../style/variable';
import {useLocation} from 'react-router-dom';

const useStyles = makeStyles(() =>
  createStyles({
    loginComponentCenter: {
      margin: 'auto',
      height: '100%',
      width: '50%',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignContent: 'center',
      alignItems: 'center'
    },
    logo: {
      display: 'flex',
      backgroundColor: DEFAULT_WHITE_COLOR,
      padding: '0 12px 10px 0',
      justifyContent: 'center'
    },
    logoImage: {
      maxHeight: '48px'
    },
    errorIcon: {
      display: 'flex',
      justifyContent: 'center',
      paddingBottom: '10px',
      '& .MuiSvgIcon-root': {
        fontSize: '3rem'
      }
    },
    errorMessage: {
      textAlign: 'center'
    }
  })
);
const PaymentErrorPage = ({
  errorMessage
}: {
  errorMessage?: string;
}): React.ReactElement => {
  const {t} = useTranslation();

  const location = useLocation<{errorMessage?: string}>();
  const errorMessageFromLocation = location.state?.errorMessage;
  const classes = useStyles();
  const defaultErrorMessage = t('PAYMENTS_LOGIN.ERROR_MESSAGE');

  return (
    <div
      className={['center-children', classes.loginComponentCenter].join(' ')}>
      <Card>
        <CardContent>
          <div className={classes.logo}>
            <MedopsLogo className={classes.logoImage} />
          </div>
          <div className={classes.errorIcon}>
            <LinkDisconnectedIcon color={'error'} />
          </div>
          <Typography variant={'subtitle1'} className={classes.errorMessage}>
            {errorMessage || errorMessageFromLocation || defaultErrorMessage}
          </Typography>
        </CardContent>
      </Card>
    </div>
  );
};

export default PaymentErrorPage;
